import React, { Component } from "react";
import { connect } from "react-redux";
import { addMessageToRedux } from "../../../../Actions/Messaging";
import { withRouterHooks } from "../../../../withRouters/withRoutersHook";
import PropTypes from "prop-types";

class CustomizeAndMoreInformation extends Component {
  static propTypes = {
    addMessageToRedux: PropTypes.func.isRequired,
    message: PropTypes.string,
    ShowMessageIntent: PropTypes.func.isRequired,
    phone_number: PropTypes.string,
    queued_for_broadcast: PropTypes.bool,
    onQueueToggle: PropTypes.func.isRequired,
  };

  handleAddMessageToRedux = () => {
    const { message, addMessageToRedux } = this.props;
    if (message) {
      addMessageToRedux(message);
    }
  };

  render() {
    const { ShowMessageIntent, phone_number, queued_for_broadcast, onQueueToggle } = this.props;

    return (
      <div className="flex flex-col w-48 bg-white rounded-xl shadow-lg border border-gray-100 py-1 overflow-hidden">
        <button
          onClick={() => {
            this.handleAddMessageToRedux();
            ShowMessageIntent(phone_number);
          }}
          className="w-full px-4 py-2.5 text-left text-sm font-inter text-gray-700 hover:bg-gray-50 transition-colors"
        >
          More information
        </button>
        <div className="h-px bg-gray-100 mx-3" />
        <button
          onClick={() => onQueueToggle(phone_number)}
          className="w-full px-4 py-2.5 text-left text-sm font-inter transition-colors hover:bg-gray-50"
        >
          {queued_for_broadcast ? (
            <span className="text-gray-700">Dequeue</span>
          ) : (
            <span className="text-emerald-700">Queue for broadcast</span>
          )}
        </button>
      </div>
    );
  }
}

export default withRouterHooks(
  connect(null, { addMessageToRedux })(CustomizeAndMoreInformation)
);
